<app-wa-table [isSortableFunc]="sortClass" [showCondition]="true" [headers]="headers()" [isDataLoading]="loading"
  [areMoreData]="areMoreData()" (loadMore)="loadMore()" [data]="data" (headerClick)="changeSort($event)">
  <ng-template [extraClass]="['wa-table__cell--fit-right']" app-column let-athlete>
                <lib-athlete-photo [id]="athlete.Id" [isTeam]="false"></lib-athlete-photo>

  </ng-template>
  <ng-template  app-column let-athlete>
    <lib-athlete-name [fname]="athlete.FName" [gname]="athlete.GName" [wnameord]="athlete.WNameOrd" [id]="athlete.Id"></lib-athlete-name>
  </ng-template>
  <ng-template  [extraClass]="['center-text']" app-column let-athlete>
    <div class="uppertext">{{athlete.Age}}</div>
  </ng-template>
  <ng-template  [extraClass]="['center-text']" app-column let-athlete>
    <div class="bubble">{{athlete.WorldRankings[0].Rnk}}</div>
  </ng-template>
  <ng-template *ngIf="categorySelected()" [extraClass]="['center-text']"  app-column let-athlete><p class="uppertext-black">{{athlete.SeasonStats[0].AverageArr}}</p></ng-template>
  <ng-template *ngIf="categorySelected()" [extraClass]="['center-text']" app-column let-athlete><p class="uppertext-black">{{athlete.SeasonStats[0].MatchWinPercentage}}%</p></ng-template>
  <ng-template *ngIf="!categorySelected()" [extraClass]="['center-text']" app-column let-athlete>
    <ng-container *ngFor="let rank of athlete.WorldRankings">
      <span class="tag tag--clickable" *ngIf="rank.Cat != ''" (click)="selectCategory(getCategoryByCode(rank.Cat))">
        {{getCategoryByCode(rank.Cat).Name}}
      </span>
    </ng-container>
  </ng-template>

  <ng-template [extraClass]="['wa-table__cell--fit-right']" app-column-responsive let-athlete>
    <lib-athlete-photo [id]="athlete.Id" [isTeam]="false"></lib-athlete-photo>
  </ng-template>
  <ng-template  app-column-responsive let-athlete>
    <lib-athlete-name [fname]="athlete.FName" [gname]="athlete.GName" [wnameord]="athlete.WNameOrd" [id]="athlete.Id"></lib-athlete-name>
    <div class="inner-info">
      <div><p class="uppertext-black">{{'Age' | transloco}}:          </p>  {{athlete.Age}}   </div>
      <div><p class="uppertext-black">{{'world_ranking' | transloco}}:          </p>  {{athlete.WorldRankings[0].Rnk}}   </div>
      <div *ngIf="!categorySelected()">
        <ng-container *ngFor="let rank of athlete.WorldRankings">
          <span class="tag tag--clickable" *ngIf="rank.Cat != ''" (click)="selectCategory(getCategoryByCode(rank.Cat))">
            {{getCategoryByCode(rank.Cat).Name}}
          </span>
        </ng-container>
      </div>
      <div *ngIf="categorySelected()"><p class="uppertext-black">{{'average_arrow' | transloco}}:    </p>  {{athlete.SeasonStats[0].AverageArr}}</div>
      <div *ngIf="categorySelected()"><p class="uppertext-black">{{'match_percent' | transloco}}:       </p>{{athlete.SeasonStats[0].MatchWinPercentage}}%</div>
    </div>
  </ng-template>

</app-wa-table>
